import { jsx as e } from "react/jsx-runtime";
import i from "./visuallyhidden.module.js";
const t = ({ children: s, ...r }) => /* @__PURE__ */ e("span", { className: i.visuallyHidden, ...r, children: s });
export {
  t as VisuallyHidden
};
